import { Collapse as KoCollapse } from 'antd';

export default   KoCollapse;
